import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';
import { Menu } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#FFF8F4]">
      {/* Mobile header */}
      <header className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-white border-b border-orange-100 px-4 py-3 flex items-center justify-between">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setSidebarOpen(true)}
          className="p-2 text-orange-600 hover:bg-orange-50"
        >
          <Menu className="w-6 h-6" />
        </Button>
        <h1 className="font-bold text-gray-900 text-base">
          Urcalportal
        </h1>
        <NotificationBell />
      </header>

      {/* Desktop top bar */}
      <div className="hidden lg:flex fixed top-0 left-64 right-0 z-30 h-14 bg-white border-b border-orange-100 items-center justify-end px-6">
        <NotificationBell />
      </div>

      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main content */}
      <main className="lg:ml-64 pt-16 lg:pt-14 p-4 sm:p-6 lg:p-8 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
